import ErrorPage from './error.page'
import { ErrorTemplate } from './error.template'

export { ErrorTemplate as ErrorPageTemplate, ErrorPage }

export default ErrorPage
